import type { ReduxState } from '@/redux/app/state';

export const userAudioSelector = (state: ReduxState) =>
  state.user.audio;

export const snoozeUntilSelector = (state: ReduxState) =>
  state.user.snoozeUntil;

export const snoozeMuteChatSelector = (state: ReduxState) =>
  state.user.snoozeMuteChat;

export const snoozeMuteCallsSelector = (state: ReduxState) =>
  state.user.snoozeMuteCalls;
